import { render } from "./SupportVisualLoginPage.vue?vue&type=template&id=585fc0a1&scoped=true&ts=true"
import script from "./SupportVisualLoginPage.vue?vue&type=script&lang=ts"
export * from "./SupportVisualLoginPage.vue?vue&type=script&lang=ts"

import "./SupportVisualLoginPage.vue?vue&type=style&index=0&id=585fc0a1&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src613357358/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-585fc0a1"]])

export default __exports__